/**
 * Interface that is captable to handle v-on callbacks
 */
interface VueOnMapType {
    [eventname: string]: (eventArgs: any) => void;
}

/**
 * This class contains all events AFFE is able to handle
 *
 * If you are triggering your own event which is not listed here, you are not able to connect AFFE to this event.
 */
class FieldEvents {

    private static readonly ALL_POSSIBLE_FIELD_EVENTS: string[] = [
        'internalUpdate', // after AFFE has updated model
        'input', // html input event
        'dirty', // ametras formular dirty event
        'abort',
        'switchsubmenu',
        'inputConfigurationChange',
        'closeSubmenuDialog',
        'close',
        'closeDialog',
        'save',
        'delete',
        'revert',
        'breadcrumb-navigate-to',
        'focus', // html focus event
        'blur', // html blur event
        'change', // html change event
        'selected', // datatable selected row event
        'click', // html click event
        'clicked',
        'click:append', // html click event within append slot
        'click:prepend', // html click event within prepend slot
        'click:append-outer', // html click event within append-outer slot
        'click:prepend-outer', // html click event within prepend-outer slot
        'dblclick', // html dblclick event within append slot
        'showadditionalinfo',
        'applyReplacementArticle',
        'update-context-parameter',
        'childmoveup', // structure el has moved to parent
        'childmovedown', // structure el has moved to child
        'childdelete', // structure el has removed
        'onclick',
        'afterUploadCompleted',
        'afterUploadDeleted', // used for multi file upload fields
        'reloadParent',
        'subnaviinparent',
        'toolbar-button-clicked',
        'check'
    ];

    /**
     * Builds a v-on captable object map to register all possible listeners.
     * @param cb the callback mechanism that handles the passthrough emitment
     */
    public buildPassthroughVueOnMapForAllEvents(cb: (eventName: string, eventArgs: any) => void) {
        const result: { [eventname: string]: (eventArgs: any) => void } = {};
        for (const currentEventName of FieldEvents.ALL_POSSIBLE_FIELD_EVENTS || []) {
            result[currentEventName] = (eventArgs: any) => {
                cb(currentEventName, eventArgs);
            };
        }
        return result;
    }
}

const FIELD_EVENTS_INSTANCE = new FieldEvents();

export {FIELD_EVENTS_INSTANCE, VueOnMapType};
